import React, { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, Link, Stack, Container } from "@mui/material";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleSmoothScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleAnchorClick = (e, id) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/", { replace: false });
      // 遷移後にスクロールを行うため遅延実行
      setTimeout(() => handleSmoothScroll(id), 100);
    } else {
      handleSmoothScroll(id);
    }
  };

  const handlePrivacyClick = useCallback(() => {
    navigate("/privacy-policy");
  }, [navigate]);

  const animatedLinkSx = {
    paddingBottom: "3px",
    backgroundImage: "linear-gradient(currentColor, currentColor)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "bottom left",
    backgroundSize: "0% 1px",
    transition: "background-size 0.3s ease-in-out",

    "&:hover": {
      backgroundSize: "100% 1px",
    },
  };

  return (
    <Box
      sx={{
        backgroundColor: "#1b2b5b",
        color: "white",
        py: { xs: 5, md: 8 },
        textAlign: "center",
      }}
    >
      <Container maxWidth="md">
        <Box
          component="img"
          src="footer/footer-icon.svg"
          alt="upro logo"
          sx={{
            width: { xs: 180, md: 240 },
            mb: { xs: 3, md: 2 },
          }}
        />

        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 1.5, md: 4 }}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 4 }}
        >
          {[
            { id: "about", label: "私たちについて" },
            { id: "service", label: "サービス紹介" },
            { id: "member", label: "メンバー紹介" },
            { id: "case", label: "事例紹介" },
            { id: "company", label: "会社概要" },
            { id: "contact", label: "お問い合わせ" },
          ].map((item) => (
            <Link
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => handleAnchorClick(e, item.id)}
              color="inherit"
              underline="none"
              sx={{ ...animatedLinkSx, fontFamily: "Roboto, sans-serif" }}
            >
              {item.label}
            </Link>
          ))}
          <Link
            component="button"
            onClick={handlePrivacyClick}
            color="inherit"
            underline="none"
            sx={{ ...animatedLinkSx, fontFamily: "Roboto, sans-serif" }}
          >
            個人情報保護方針
          </Link>
        </Stack>

        <Typography
          variant="body2"
          color="inherit"
          sx={{ fontFamily: "Roboto, sans-serif" }}
        >
          © 2026 YouProduce Co.,ltd.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
